import { render, staticRenderFns } from "./LocaleMenu.vue?vue&type=template&id=8d2cb95a&"
import script from "./LocaleMenu.vue?vue&type=script&lang=ts&"
export * from "./LocaleMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports